// extracted by mini-css-extract-plugin
export default {"main":"rootLayout_main__XNznP"};